// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trending-grid {
  display: grid;
  gap: 25px;
  grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/product/components/product-trending-items/product-trending-items.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,4DAAA;AACF","sourcesContent":[".trending-grid {\n  display: grid;\n  gap: 25px;\n  grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
